import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

import { ComponentLoader } from '../ComponentLoader/ComponentLoader';
import { fetchTradeOnboardingEligibility } from './fetchTradeOnboardingEligibility';

export const PDP_PLACEMENT = 'pdp';
export const SB_PLACEMENT = 'sb';
export const DM_PRO_PLACEMENT = 'dmPro';
export const DM_STANDARD_PLACEMENT = 'dmStandard';

const importPdpTradeDesignManagerProOnboardingCoachmark = () => {
    return import(
        /* webpackChunkName: "PdpRespTradeDesignManagerProOnboardingCoachmark" */
        '../../pdp/PdpRespTradeDesignManagerOnboardingCoachmark/PdpRespTradeDesignManagerProOnboardingCoachmark'
    ).then(moduleExport => moduleExport.PdpRespTradeDesignManagerProOnboardingCoachmark);
};

const importPdpTradeDesignManagerStandardOnboardingCoachmark = () => {
    return import(
        /* webpackChunkName: "PdpRespTradeDesignManagerStandardOnboardingCoachmark" */
        '../../pdp/PdpRespTradeDesignManagerOnboardingCoachmark/PdpRespTradeDesignManagerStandardOnboardingCoachmark'
    ).then(moduleExport => moduleExport.PdpRespTradeDesignManagerStandardOnboardingCoachmark);
};

const importPdpTradeOnboardingCoachmark = () => {
    return import(
        /* webpackChunkName: "PdpTradeOnboardingCoachmark" */
        '../../pdp/PdpRespTradeOnboardingCoachmark/PdpRespTradeOnboardingCoachmark'
    ).then(moduleExport => moduleExport.PdpRespTradeOnboardingCoachmark);
};

const importSbTradeOnboardingCoachmark = () => {
    return import(
        /* webpackChunkName: "SbTradeOnboardingCoachmark" */
        '../../finding/SbRespTradeOnboardingCoachmark/SbRespTradeOnboardingCoachmark'
    ).then(moduleExport => moduleExport.SbRespTradeOnboardingCoachmark);
};

export class TradeOnboardingCoachmarkConditionalLoaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.checkEligibility = this.checkEligibility.bind(this);
        this.getLoadFunc = this.getLoadFunc.bind(this);
        this.state = {
            eligibilityChecked: false,
            userEligibleForOboarding: false, // updated when relay prop received
        };
    }

    componentDidMount() {
        this.checkEligibility();
    }

    componentDidUpdate() {
        this.checkEligibility();
    }

    checkEligibility() {
        const { relay, user } = this.props;
        const { eligibilityChecked } = this.state;
        const relayEnvironment = get(relay, 'environment');
        const userId = get(user, 'serviceId');

        if (eligibilityChecked || !relayEnvironment || !userId) {
            return;
        }

        this.setState({ eligibilityChecked: true }, () => {
            fetchTradeOnboardingEligibility(relayEnvironment, userId).then(
                userEligibleForOboarding => {
                    this.setState({ userEligibleForOboarding });
                }
            );
        });
    }

    getLoadFunc() {
        switch (this.props.type) {
            case PDP_PLACEMENT:
                return importPdpTradeOnboardingCoachmark;
            case SB_PLACEMENT:
                return importSbTradeOnboardingCoachmark;
            case DM_PRO_PLACEMENT:
                return importPdpTradeDesignManagerProOnboardingCoachmark;
            case DM_STANDARD_PLACEMENT:
                return importPdpTradeDesignManagerStandardOnboardingCoachmark;
            default:
                return null;
        }
    }

    render() {
        const { item, showModal } = this.props;
        const { userEligibleForOboarding } = this.state;

        const loadFunc = this.getLoadFunc();

        if (!loadFunc) {
            console.warn(
                'cannot render onboarding coachmark because pdp/sb indicator not provided'
            );
            return null;
        }

        return (
            <ComponentLoader
                load={userEligibleForOboarding}
                importFunc={loadFunc}
                useLoadingComponent={false}
                itemId={get(item, 'serviceId')}
                showModal={showModal}
            />
        );
    }
}

TradeOnboardingCoachmarkConditionalLoaderComponent.propTypes = {
    type: PropTypes.oneOf([PDP_PLACEMENT, SB_PLACEMENT, DM_PRO_PLACEMENT, DM_STANDARD_PLACEMENT]),
    item: PropTypes.object,
    relay: PropTypes.object,
    showModal: PropTypes.bool,
    user: PropTypes.object,
};

export const TradeOnboardingCoachmarkConditionalLoader = createFragmentContainer(
    TradeOnboardingCoachmarkConditionalLoaderComponent,
    {
        item: graphql`
            fragment TradeOnboardingCoachmarkConditionalLoader_item on Item {
                serviceId
            }
        `,
        user: graphql`
            fragment TradeOnboardingCoachmarkConditionalLoader_user on User {
                serviceId
            }
        `,
    }
);
